import React, {Component} from 'react'

import '../../styles/TradeCryptocurrenciesStyles/robotichand.css'

import Base from './../../resources/TradeCryptoResources/base.svg'
import ExtensionOne from './../../resources/TradeCryptoResources/extension-one.svg'
import ExtensionTwo from './../../resources/TradeCryptoResources/extension-two.svg'
import Hand from './../../resources/TradeCryptoResources/hand.svg'
import Coin from './../../resources/TradeCryptoResources/coin.svg'
import Finger from './../../resources/TradeCryptoResources/finger.svg'


export default class RoboticHand extends Component{
    render(){
        return(
            <div className="robotic-hand__container">
                <img className="rh__base" src={Base} />
                <div className="rh__extension-rotate-container">
                    <img className="rh__extension-one" src={ExtensionOne} />
                    <div className="rh__extension-rotate-container-two">
                        <img className="rh__extension-two" src={ExtensionTwo} />
                        <div className="rh__extension-rotate-container-three">
                            <img className="rh__hand" src={Hand} />
                            <img className="rh__finger" src={Finger} />
                            <img className="rh__coin" src={Coin}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/TradeCrypto/RoboticHand.js